import i18n from '../locales/index'
/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
//  *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

import Main from '@/components/main';
import Home from '@/pages/single-page/home';
import Shops from '@/pages/shops';
import Orders from '@/pages/orders';
import OrderShow from '@/pages/orders/show';
import P401 from '@/pages/error-page/401.vue';
import P500 from '@/pages/error-page/500.vue';
import P404 from '@/pages/error-page/404.vue';
import store from '@/store';

export default [{
    path: '/login',
    name: 'login',
    meta: {
      title: i18n.t('router_routers_1246'),
      hideInMenu: true,
    },
    component: () => import('@/pages/account/login'),
  },
  {
    path: '/reset',
    name: 'reset',
    meta: {
      title: i18n.t('router_routers_1247'),
      hideInMenu: true,
    },
    component: () => import('@/pages/account/reset'),
  },
  {
    path: '/',
    name: 'shops',
    redirect: '/shops',
    component: Main,
    meta: {
      hideInBread: true,
      notCache: true,
      title: i18n.t('router_routers_1248'),
      icon: 'ios-appstore',
      access: ['editor', 'admin'],
    },
    children: [{
      path: '/shops',
      name: 'shops-shops',
      meta: {
        icon: 'ios-appstore',
        title: i18n.t('router_routers_1249'),
      },
      component: Shops,
    }, ],
  },
  {
    path: '/data',
    name: 'home',
    meta: {
      require_permission: 'dashboard:view',
      title: i18n.t('router_routers_1250'),
      notCache: true,
      icon: 'ios-pie',
    },
    redirect: '/data/home',
    component: Main,
    children: [{
        path: '/data/home',
        name: 'home',
        meta: {
          require_permission: 'dashboard:view',
          title: i18n.t('router_routers_1250'),
          notCache: true,
          icon: 'ios-pie',
        },
        component: Home,
      },
      {
        path: '/data/statement_sale',
        name: 'statement_sale',
        meta: {
          require_permission: 'dashboard:view',
          title: i18n.t('pages_dashboards_statement_sale_index_398'),
          notCache: true,
          icon: 'ios-pie',
        },
        component: () => import('@/pages/dashboards/statement_sale/index'),
      },
      {
        path: '/data/statement_product',
        name: 'statement_product',
        meta: {
          require_permission: 'dashboard:view',
          title: i18n.t('router_routers_1251'),
          notCache: true,
          icon: 'ios-pie',
        },
        component: () => import('@/pages/dashboards/statement_product/index'),
      },
    ],
  },
  // {
  //   path: '/',
  //   name: '_statistics',
  //   component: Main,
  //   meta: {
  //     notCache: true,
  //     icon: 'ios-pie',
  //   },
  //   children: [
  //     {
  //       path: '/statistics',
  //       name: 'statistics',
  //       meta: {
  //         require_permission: 'statistics:view',
  //         title: '数据大盘',
  //         notCache: true,
  //         icon: 'ios-pie',
  //       },
  //       component: () => import('@/pages/statistics'),
  //     }
  //   ]
  // },
  {
    path: '/products',
    name: 'products',
    meta: {
      icon: 'logo-buffer',
      title: i18n.t('router_routers_1252'),
      access: ['editor', 'admin'],
      require_permission: 'products:group',
    },
    component: Main,
    children: [
      // {
      //   path: 'products',
      //   name: 'products-booking_store_products',
      //   meta: {
      //     icon: 'ios-infinite',
      //     title: '采购商品管理'
      //   },
      //   component: () => import('@/pages/booking_store_products')
      // },
      {
        path: '/products/base_data',
        name: 'base_data-categories',
        meta: {
          icon: 'ios-list',
          title: i18n.t('pages_booking_store_products_index_213'),
          require_permission: 'basic:product_category',
        },
        component: () => import('@/pages/categories'),
      },
      {
        path: '/products/units',
        name: 'categories-units',
        meta: {
          icon: 'ios-planet',
          title: i18n.t('pages_booking_store_products_index_214'),
          require_permission: 'basic:product_unit',
        },
        component: () => import('@/pages/units'),
      },
      {
        path: '/products/:id/edit',
        name: 'products-edit',
        meta: {
          icon: 'md-attach',
          title: i18n.t('router_routers_1253'),
          hideInMenu: true,
          require_permission: 'products:product_edit',
        },
        component: () => import('@/pages/products/edit'),
      },
      {
        path: '/products/product_specs',
        name: 'product_specs',
        meta: {
          icon: 'ios-browsers',
          title: i18n.t('pages_booking_store_products_index_215'),
          require_permission: 'products:product_specs',
        },
        component: () => import('@/pages/wechat_product_specs'),
      },
      {
        path: '/products/product_groups',
        name: 'product_groups',
        meta: {
          icon: 'ios-browsers',
          title: i18n.t('router_routers_1254'),
          require_permission: 'products:product_groups',
        },
        component: () => import('@/pages/mall_groups'),
      },
      {
        path: '/products/materials',
        name: 'product_materials',
        meta: {
          icon: 'ios-basket-outline',
          title: i18n.t('pages_products_edit_828'),
          require_permission: 'products:product_materials',
        },
        component: () => import('@/pages/materials'),
      },
      {
        path: '/products',
        name: 'products-products',
        meta: {
          icon: 'md-attach',
          title: i18n.t('router_routers_1252'),
          require_permission: 'products:index',
        },
        component: () => import('@/pages/products/index.v2'),
      },
      {
        path: '/products/products-switch',
        name: 'products-switch',
        meta: {
          icon: 'ios-planet',
          title: i18n.t('router_routers_1255'),
          require_permission: 'products:switch',
        },
        component: () => import('@/pages/product_switch'),
      },
      // {
      //   path: ':id/stocks',
      //   name: 'products-stocks',
      //   meta: {
      //     icon: '_qq',
      //     title: '库存盘点',
      //     hideInMenu: true
      //   },
      //   component: () => import('@/pages/stocks')
      // }
    ],
  },
  {
    path: '/orders',
    name: 'orders',
    meta: {
      hideInBread: true,
      icon: 'logo-buffer',
      title: i18n.t('router_routers_1256'),
      access: ['editor', 'admin'],
    },
    component: Main,
    children: [{
        path: '/orders',
        name: 'orders-orders',
        meta: {
          icon: 'ios-document',
          title: i18n.t('router_routers_1256'),
          require_permission: 'orders:index',
        },
        component: Orders,
      },
      {
        path: '/orders/:id',
        name: 'orders-items',
        meta: {
          icon: 'ios-attach',
          hideInMenu: true,
          title: i18n.t('pages_orders_show_644'),
          require_permission: 'orders:index',
        },
        component: OrderShow,
      },
    ],
  },
  {
    path: '/customers',
    name: 'customers',
    meta: {
      icon: 'md-people',
      access: ['editor', 'admin'],
      title: i18n.t('router_routers_1257'),
      require_permission: 'vip:index',
    },
    component: Main,
    children: [{
        path: '/customers/list',
        name: 'customers-customers',
        meta: {
          icon: 'md-people',
          title: i18n.t('router_routers_1257'),
          require_permission: 'vip:list',
        },
        component: () => import('@/pages/customers'),
      },
      {
        path: '/customers/customer_levels',
        name: 'customer_levels',
        meta: {
          icon: 'md-people',
          title: i18n.t('router_routers_1258'),
          require_permission: 'vip:customer_levels',
        },
        component: () => import('@/pages/customer_level'),
      },
      {
        path: '/customers/bills',
        name: 'bills-bills',
        meta: {
          icon: 'md-trending-up',
          title: i18n.t('router_routers_1259'),
          require_permission: 'vip:charge',
        },
        component: () => import('@/pages/bills'),
      },
      {
        path: '/customers/:id/bills',
        name: 'customers-bills',
        meta: {
          icon: 'md-trending-up',
          hideInMenu: true,
          title: i18n.t('pages_customers_index_323'),
          require_permission: 'vip:charge_history',
        },
        component: () => import('@/pages/customers/bills'),
      },
      {
        path: '/customers/:id/orders',
        name: 'customers-orders',
        meta: {
          icon: '_qq',
          hideInMenu: true,
          title: i18n.t('router_routers_1260'),
          require_permission: 'vip:order_history',
        },
        component: () => import('@/pages/customers/orders'),
      },
      {
        path: '/customers/score_products',
        name: 'score_products',
        meta: {
          icon: 'md-grid',
          title: i18n.t('pages_score_product_change_records_index_924'),
          require_permission: 'vip:score_products',
        },
        component: () => import('@/pages/score_products'),
      },
      {
        path: '/customers/score_product_change_records',
        name: 'score-products-change-records',
        meta: {
          icon: 'md-grid',
          title: i18n.t('router_routers_1261'),
          require_permission: 'vip:score_products_change_record',
        },
        component: () => import('@/pages/score_product_change_records'),
      },
    ],
  },
  // {
  //   path: '/materials',
  //   name: 'materials',
  //   meta: {
  //     icon: 'ios-basket-outline',
  //     title: '小料管理',
  //     access: ['editor', 'admin'],
  //     hideInBread: true
  //   },
  //   component: Main,
  //   children: [
  //     {
  //       path: 'materials',
  //       name: 'materials-materials',
  //       meta: {
  //         icon: 'ios-basket-outline',
  //         title: '小料管理',
  //         require_permission: 'materials:index',
  //       },
  //       component: () => import('@/pages/materials')
  //     },
  //   ]
  // },
  {
    path: '/marketing',
    name: 'marketing',
    meta: {
      icon: 'md-people',
      access: ['editor', 'admin'],
      title: i18n.t('router_routers_1262'),
      require_permission: 'marketing:index',
    },
    component: Main,
    children: [{
        path: '/marketing/enough_consume_discount',
        name: 'enough_consume_discount',
        meta: {
          icon: 'md-grid',
          title: i18n.t('pages_enough_consume_discount_index_482'),
          require_permission: 'marketing:enough_consume_discount',
        },
        component: () => import('@/pages/enough_consume_discount'),
      },
      {
        path: '/marketing/first_order_discount',
        name: 'first_order_discount',
        meta: {
          icon: 'md-grid',
          title: i18n.t('pages_orders_show_689'),
          require_permission: 'marketing:first_order_discount',
        },
        component: () => import('@/pages/first_order_discount'),
      },
      {
        path: '/marketing/birthday_discount',
        name: 'birthday_discount',
        meta: {
          icon: 'md-grid',
          title: i18n.t('router_routers_1263'),
          require_permission: 'marketing:birthday_discount',
        },
        component: () => import('@/pages/birthday_discount'),
      },
      {
        path: '/marketing/combo',
        name: 'combo',
        meta: {
          icon: 'md-grid',
          title: i18n.t('router_routers_1264'),
          require_permission: 'marketing:combo',
        },
        component: () => import('@/pages/combo'),
      },
      {
        path: '/marketing/limited_time_activity',
        name: 'limited_time_activity',
        meta: {
          icon: 'md-grid',
          title: i18n.t('pages_limited_time_activity_index_585'),
          require_permission: 'marketing:limited_time_activity',
        },
        component: () => import('@/pages/limited_time_activity'),
      },
      {
        path: '/marketing/offline_coupon_discount',
        name: 'offline_coupon_discount',
        meta: {
          icon: 'md-grid',
          title: i18n.t('pages_orders_index_642'),
          require_permission: 'marketing:offline_coupon_discount',
        },
        component: () => import('@/pages/offline_coupon_discount'),
      },
      {
        path: '/marketing/schedule_display_product',
        name: 'schedule_display_product',
        meta: {
          icon: 'md-attach',
          title: i18n.t('router_routers_1265'),
        },
        component: () => import('@/pages/schedule_display_product'),
      },
      {
        path: '/marketing/score_reward',
        name: 'score_reward',
        meta: {
          icon: 'md-attach',
          title: i18n.t('router_routers_1266'),
        },
        component: () => import('@/pages/score_reward'),
      },
      {
        path: '/marketing/deduct_coupon_rule',
        name: 'deduct_coupon_rule',
        meta: {
          icon: 'md-attach',
          title: i18n.t('router_routers_1267'),
        },
        component: () => import('@/pages/deduct_coupon_rule'),
      },
      {
        path: '/marketing/deduct_coupon',
        name: 'deduct_coupon',
        meta: {
          icon: 'md-attach',
          title: i18n.t('router_routers_1268'),
        },
        component: () => import('@/pages/deduct_coupon'),
      },
      {
        path: '/marketing/seckill',
        name: 'seckill',
        meta: {
          icon: 'md-attach',
          title: i18n.t('router_routers_1269'),
        },
        component: () => import('@/pages/seckill'),
      },
    ],
  },
  {
    path: '/desks',
    name: 'desks',
    meta: {
      icon: 'logo-buffer',
      title: i18n.t('router_routers_1270'),
      require_permission: 'desk:index',
    },
    component: Main,
    children: [{
        path: 'desk_partitions',
        name: 'desk_partitions',
        meta: {
          icon: 'ios-attach',
          title: i18n.t('router_routers_1271'),
          require_permission: 'desk:partition',
        },
        component: () => import('@/pages/desk_partition'),
      },
      {
        path: 'desks',
        name: 'desks-desks',
        meta: {
          icon: 'ios-document',
          title: i18n.t('router_routers_1272'),
          require_permission: 'desk:desk',
        },
        component: () => import('@/pages/desk'),
      },
      {
        path: 'seats',
        name: 'seats-seats',
        meta: {
          icon: 'ios-document',
          title: i18n.t('router_routers_1273'),
          hideInMenu: true,
          require_permission: 'desk:seat',
        },
        component: () => import('@/pages/seat'),
      },
    ],
  },
  {
    path: '/ai',
    name: 'ai',
    meta: {
      icon: 'logo-buffer',
      title: i18n.t('router_routers_1274'),
      require_permission: 'ai:index',
    },
    component: Main,
    children: [{
        path: '/ai/feature',
        name: 'ai-list',
        meta: {
          icon: 'ios-attach',
          title: i18n.t('router_routers_1275'),
          require_permission: 'ai:feature',
        },
        component: () => import('@/pages/ai'),
      },
      {
        path: '/ai/image',
        name: 'ai-image',
        meta: {
          icon: 'ios-attach',
          title: i18n.t('router_routers_1276'),
          require_permission: 'ai:image',
        },
        component: () => import('@/pages/ai/image'),
      },
      {
        path: '/ai/thirdParty',
        name: 'ai-thirdParty',
        meta: {
          icon: 'ios-attach',
          title: i18n.t('router_routers_1277'),
          require_permission: 'ai:thirdParty',
        },
        component: () => import('@/pages/ai/thirdParty'),
      }
    ],
  },
  {
    path: '/promote',
    name: 'promote',
    meta: {
      icon: 'logo-buffer',
      title: i18n.t('router_routers_1278'),
      require_permission: 'promote:index',
    },
    component: Main,
    children: [{
        path: '/promote/company',
        name: 'promote-company',
        meta: {
          icon: 'ios-attach',
          title: i18n.t('router_routers_1279'),
          require_permission: 'promote:company',
        },
        component: () => import('@/pages/promote/companies'),
      },
      {
        path: '/promote/company/:id/bills',
        name: 'promote-company-bills',
        meta: {
          icon: 'ios-attach',
          title: i18n.t('router_routers_1280'),
          require_permission: 'promote:company',
          hideInMenu: true,
        },
        component: () => import('@/pages/promote/company_bills'),
      },
      {
        path: '/promote/staff',
        name: 'promote-staff',
        meta: {
          icon: 'ios-attach',
          title: i18n.t('router_routers_1281'),
          require_permission: 'promote:staff',
        },
        component: () => import('@/pages/promote'),
      },
      {
        path: '/promote/staff/:id/bills',
        name: 'promote-staff-bills',
        meta: {
          icon: 'ios-attach',
          title: i18n.t('router_routers_1282'),
          require_permission: 'promote:staff',
          hideInMenu: true,
        },
        component: () => import('@/pages/promote/staff_bills'),
      },
      {
        path: '/promote/:target/bills/:id',
        name: 'promote-target-bills',
        meta: {
          icon: 'ios-attach',
          title: i18n.t('router_routers_1283'),
          hideInMenu: true,
        },
        component: () => import('@/pages/promote/bill_info'),
      },
      // {
      //   path: '/promote/setting',
      //   name: 'promote-setting',
      //   meta: {
      //     icon: 'ios-attach',
      //     title: '推广设置',
      //     require_permission: 'promote:setting',
      //   },
      //   component: () => import('@/pages/promote/setting'),
      // }
    ],
  },
  {
    path: '/',
    name: 'sms',
    meta: {
      hideInBread: true,
      title: i18n.t('router_routers_1284'),
      icon: 'md-grid',
      access: ['editor', 'admin'],
      require_permission: 'sms:index',
    },
    component: Main,
    children: [{
      path: 'sms/notes',
      name: 'sms-notes',
      meta: {
        icon: 'md-stopwatch',
        title: i18n.t('router_routers_1284'),
        require_permission: 'sms:sms_history',
      },
      component: () => import('@/pages/sms_notes'),
    }],
  },
  {
    path: '/banners',
    name: 'banners',
    meta: {
      icon: 'ios-book',
      title: i18n.t('router_routers_1285'),
      access: ['editor', 'admin'],
      hideInBread: true,
    },
    component: Main,
    children: [{
      path: '/banners',
      name: 'banners-banner',
      meta: {
        icon: 'md-attach',
        title: i18n.t('router_routers_1285'),
        require_permission: 'banners:index',
      },
      component: () => import('@/pages/banners'),
    }, ],
  },
  {
    path: '/',
    name: 'printer',
    meta: {
      icon: 'ios-book',
      title: i18n.t('router_routers_1286'),
      access: ['editor', 'admin'],
      hideInBread: true,
      require_permission: 'printer:index',
    },
    component: Main,
    children: [{
      path: '/printer',
      name: 'printer',
      meta: {
        icon: 'md-attach',
        title: i18n.t('router_routers_1286'),
        require_permission: 'printer:printer_admin',
      },
      component: () => import('@/pages/printer'),
    }, ],
  },
  {
    path: '/messages',
    name: 'messages',
    meta: {
      icon: 'ios-book',
      title: i18n.t('router_routers_1287'),
      access: ['editor', 'admin'],
      require_permission: 'notification:index',
    },
    component: Main,
    children: [
      // {
      //   path: 'messages',
      //   name: 'messages-messages',
      //   meta: {
      //     icon: 'ios-infinite',
      //     title: '系统通知',
      //     require_permission: 'notification:system',
      //   },
      //   component: () => import('@/pages/messages'),
      // },
      {
        path: '/messages/waters',
        name: 'waters-waters',
        meta: {
          icon: 'ios-planet',
          title: i18n.t('pages_cleaner_index_264'),
          require_permission: 'notification:sales_history',
        },
        component: () => import('@/pages/waters'),
      },
      {
        path: '/messages/history',
        name: 'products_op_history',
        meta: {
          icon: 'md-attach',
          title: i18n.t('router_routers_1288'),
          require_permission: 'products:products_op_history',
        },
        component: () => import('@/pages/products_op_history'),
      },
      {
        path: '/messages/balance_transaction',
        name: 'messages-balance_transaction',
        meta: {
          icon: 'ios-planet',
          title: i18n.t('router_routers_1289'),
          require_permission: 'notification:sales_history',
        },
        component: () => import('@/pages/balance_transaction'),
      },
      {
        path: '/messages/payments',
        name: 'payments-payments',
        meta: {
          icon: 'ios-planet',
          title: i18n.t('router_routers_1290'),
          require_permission: 'notification:sales_history',
        },
        component: () => import('@/pages/payments'),
      },
    ],
  },
  // {
  //   path: '/',
  //   name: 'analysis',
  //   meta: {
  //     icon: 'ios-book',
  //     title: '统计分析',
  //     access: ['editor', 'admin'],
  //     hideInBread: true
  //   },
  //   component: Main,
  //   children: [
  //     {
  //       path: 'analysis',
  //       name: 'analysis-messages',
  //       meta: {
  //         icon: 'ios-infinite',
  //         title: '订单收款统计'
  //       },
  //       component: () => import('@/pages/messages')
  //     },
  //     {
  //       path: 'analysis/waters',
  //       name: 'analysis-waters',
  //       meta: {
  //         icon: 'ios-planet',
  //         title: '采购付款统计'
  //       },
  //       component: () => import('@/pages/waters')
  //     },
  //     {
  //       path: 'analysis',
  //       name: 'analysis-messages',
  //       meta: {
  //         icon: 'ios-infinite',
  //         title: '销售-发货-退货报表'
  //       },
  //       component: () => import('@/pages/messages')
  //     },
  //     {
  //       path: 'analysis/waters',
  //       name: 'analysis-waters',
  //       meta: {
  //         icon: 'ios-planet',
  //         title: '采购-入库-退货报表'
  //       },
  //       component: () => import('@/pages/waters')
  //     },
  //     {
  //       path: 'analysis/waters',
  //       name: 'analysis-waters',
  //       meta: {
  //         icon: 'ios-planet',
  //         title: '产品库存'
  //       },
  //       component: () => import('@/pages/waters')
  //     }
  //   ]
  // },
  {
    path: '/base_data',
    name: 'base_data',
    meta: {
      icon: 'logo-buffer',
      title: i18n.t('router_routers_1291'),
      require_permission: 'basic:index',
    },
    component: Main,
    children: [{
        path: '/base_data/depots',
        name: 'suppliers-depots',
        meta: {
          icon: 'md-grid',
          title: i18n.t('pages_cleaner_index_260'),
          require_permission: 'basic:warehouse',
        },
        component: () => import('@/pages/depots'),
      },
      {
        path: '/base_data/suppliers',
        name: 'suppliers-suppliers',
        meta: {
          icon: 'md-grid',
          title: i18n.t('pages_bookings_index_229'),
          require_permission: 'basic:suppliers',
        },
        component: () => import('@/pages/suppliers'),
      },
    ],
  },
  {
    path: '/booking',
    name: 'cg',
    meta: {
      icon: 'ios-book',
      title: i18n.t('router_routers_1292'),
      access: ['editor', 'admin'],
      require_permission: 'purchase:index',
    },
    component: Main,
    children: [{
        path: '/booking/list',
        name: 'cg-booking',
        meta: {
          icon: 'ios-infinite',
          title: i18n.t('router_routers_1293'),
          require_permission: 'purchase:list',
        },
        component: () => import('@/pages/bookings'),
      },
      {
        path: '/booking/new',
        name: 'cg-booking-new',
        meta: {
          icon: 'ios-infinite',
          title: i18n.t('router_routers_1294'),
          require_permission: 'purchase:create',
        },
        component: () => import('@/pages/bookings/new'),
      },
      {
        path: '/booking/:id/detail',
        name: 'cg-booking-detail',
        meta: {
          icon: '_qq',
          hideInMenu: true,
          title: i18n.t('pages_bookings_index_231'),
          require_permission: 'purchase:detail',
        },
        component: () => import('@/pages/bookings/detail'),
      },
      {
        path: '/booking/warehouse',
        name: 'cg-warehouse',
        meta: {
          icon: 'ios-planet',
          title: i18n.t('router_routers_1295'),
          require_permission: 'purchase:instock_list',
        },
        component: () => import('@/pages/warehouses'),
      },
      {
        path: '/booking/warehouse/new',
        name: 'cg-warehouse-new',
        meta: {
          icon: 'ios-planet',
          title: i18n.t('pages_warehouses_index_1141'),
          require_permission: 'purchase:instock_create',
        },
        component: () => import('@/pages/warehouses/new'),
      },
      // {
      //   path: 'analysis',
      //   name: 'analysis-messages',
      //   meta: {
      //     icon: 'ios-infinite',
      //     title: '采购退货'
      //   },
      //   component: () => import('@/pages/messages')
      // },
      // {
      //   path: 'analysis/waters',
      //   name: 'analysis-waters',
      //   meta: {
      //     icon: 'ios-planet',
      //     title: '采购产品统计'
      //   },
      //   component: () => import('@/pages/waters')
      // },
      // {
      //   path: 'analysis/waters',
      //   name: 'analysis-waters',
      //   meta: {
      //     icon: 'ios-planet',
      //     title: '采购入库统计'
      //   },
      //   component: () => import('@/pages/waters')
      // },
      // {
      //   path: 'analysis/waters',
      //   name: 'analysis-waters',
      //   meta: {
      //     icon: 'ios-planet',
      //     title: '采购退货统计'
      //   },
      //   component: () => import('@/pages/waters')
      // }
    ],
  },
  {
    path: '/inventory',
    name: 'inventory',
    meta: {
      icon: 'ios-book',
      title: i18n.t('router_routers_1296'),
      access: ['editor', 'admin'],
      require_permission: 'inventory:index',
    },
    component: Main,
    children: [{
        path: '/inventory/check',
        name: 'inventory-check',
        meta: {
          icon: 'md-attach',
          title: i18n.t('router_routers_1297'),
          require_permission: 'inventory:check',
        },
        component: () => import('@/pages/product_stocks'),
      },
      {
        path: '/inventory/check_records',
        name: 'inventory-check_records',
        meta: {
          icon: '_qq',
          title: i18n.t('pages_cleaner_index_269'),
          require_permission: 'inventory:check_history',
        },
        component: () => import('@/pages/stocks'),
      },
      // {
      //   path: 'db',
      //   name: 'kc-db',
      //   meta: {
      //     icon: 'ios-infinite',
      //     title: '库存调拨'
      //   },
      //   component: () => import('@/pages/bookings')
      // },
      {
        path: '/inventory/records',
        name: 'inventory-records',
        meta: {
          icon: 'ios-infinite',
          title: i18n.t('pages_cleaner_index_270'),
          require_permission: 'inventory:inventory_history',
        },
        component: () => import('@/pages/breakages'),
      },
    ],
  },
  {
    path: '/settings',
    name: 'settings',
    meta: {
      title: i18n.t('router_routers_1298'),
      icon: 'ios-play',
      access: ['editor', 'admin'],
      require_permission: 'settings:index',
    },
    component: Main,
    children: [{
        path: '/settings/user_shops',
        name: 'user_shops-user_shops',
        meta: {
          icon: 'md-people',
          title: i18n.t('router_routers_1299'),
          require_permission: 'settings:stuffs',
        },
        component: () => import('@/pages/user_shops'),
      },
      {
        path: '/settings/user_shops',
        name: 'user_shops-user_shops',
        meta: {
          icon: 'md-people',
          title: i18n.t('router_routers_1299'),
          require_permission: 'settings:stuffs',
        },
        component: () => import('@/pages/user_shops'),
      },
      {
        path: '/settings/user_roles',
        name: 'user_shops-user_roles',
        meta: {
          icon: 'ios-list',
          title: i18n.t('router_routers_1300'),
          require_permission: 'settings:roles',
        },
        component: () => import('@/pages/roles'),
      },
      {
        path: '/settings/user_role_permissions/:id',
        name: 'user_shops-user_role_permissions',
        meta: {
          icon: 'ios-list',
          title: i18n.t('router_routers_1301'),
          hideInMenu: true,
          require_permission: 'settings:permission',
        },
        component: () => import('@/pages/roles/permissions'),
      },
      {
        path: '/settings/lcsw_accounts',
        name: 'settings-lcsw_accounts',
        meta: {
          icon: 'md-card',
          title: i18n.t('router_routers_1302'),
          require_permission: 'settings:payment',
        },
        component: () => import('@/pages/lcsw_accounts'),
      },
      {
        path: '/settings/city_shop_freights',
        name: 'city_shop_freights',
        meta: {
          icon: 'md-attach',
          title: i18n.t('router_routers_1303'),
          require_permission: 'settings:city_shop_freights',
        },
        component: () => import('@/pages/city_shop_freights'),
      },
      {
        path: '/settings/take_out',
        name: 'settings-take_out',
        meta: {
          icon: 'md-paper-plane',
          title: i18n.t('router_routers_1304'),
          require_permission: 'settings:take_out',
        },
        component: () => import('@/pages/settings/take_out'),
      },
       {
        path: '/settings/taxes',
        name: 'settings-taxes',
        meta: {
          icon: 'md-paper-plane',
          title: i18n.t('setting_new_1344'),
          require_permission: 'settings:taxes',
        },
        component: () => import('@/pages/taxes'),
      },
      {
        path: '/settings/suZhouPoints',
        name: 'settings-suZhouPoints',
        meta: {
          icon: 'md-paper-plane',
          title: i18n.t('router_routers_1312'),
          require_permission: 'settings:suZhouPoints',
        },
        component: () => import('@/pages/settings/suZhouPoints'),
      },
      {
        path: '/settings/restaurant',
        name: 'settings-restaurant',
        meta: {
          icon: 'md-paper-plane',
          title: i18n.t('router_routers_1305'),
          require_permission: 'settings:restaurant',
        },
        component: () => import('@/pages/settings/restaurant'),
      },
      {
        path: '/settings/system',
        name: 'settings-system',
        meta: {
          icon: 'md-podium',
          title: i18n.t('router_routers_1306'),
          require_permission: 'settings:system',
        },
        component: () => import('@/pages/settings'),
      },
      {
        path: '/settings/keyboard',
        name: 'settings-keyboard_shortcut',
        meta: {
          icon: 'md-podium',
          title: i18n.t('router_routers_1307'),
          require_permission: 'settings:keyboard_shortcut',
        },
        component: () => import('@/pages/keyboard_shortcut'),
      },
      {
        path: '/settings/charge_coupons',
        name: 'customers-charge_coupons',
        meta: {
          icon: 'logo-usd',
          title: i18n.t('router_routers_1308'),
          require_permission: 'settings:charge_templates',
        },
        component: () => import('@/pages/charge_coupons'),
      },
      {
        path: '/settings/cleaner',
        name: 'settings-cleaner',
        meta: {
          icon: 'md-card',
          title: i18n.t('router_routers_1309'),
          require_permission: 'settings:data_delete',
        },
        component: () => import('@/pages/cleaner'),
      },
    ],
  },
  {
    path: '/wechat_mp',
    name: 'wechat_mp',
    meta: {
      icon: 'ios-book',
      title: i18n.t('router_routers_1310'),
      access: ['editor', 'admin'],
      hideInBread: true,
      require_permission: 'miniprogram:index',
    },
    component: Main,
    children: [{
        path: '/wechat_mp/wechat_configs',
        name: 'wechat_mp-wechat_configs',
        meta: {
          icon: 'ios-radio',
          title: i18n.t('router_routers_1311'),
          require_permission: 'miniprogram:wechat',
          visible: function () {
            const info = (store.state.editor && store.state.editor.me) || {};
            return info.chain_store_manner !== 'chain';
          },
        },
        component: () => import('@/pages/wechat_configs'),
      },
      {
        path: '/wechat_mp/wechat_config_success',
        name: 'wechat_mp-wechat_config_success',
        meta: {
          icon: 'ios-radio',
          title: i18n.t('router_routers_1311'),
          hideInBread: true,
          hideInMenu: true,
        },
        component: () => import('@/pages/wechat_configs/success'),
      },
      // {
      //   path: 'products',
      //   name: 'wechat_products',
      //   meta: {
      //     icon: 'ios-browsers',
      //     title: '商品设置',
      //     require_permission: 'miniprogram:products'
      //   },
      //   component: () => import('@/pages/wechat_products')
      // },
      // {
      //   path: 'products/:id/edit',
      //   name: 'wechat_products__edit',
      //   meta: {
      //     icon: 'ios-browsers',
      //     title: '商品编辑',
      //     hideInMenu: true,
      //     require_permission: 'miniprogram:product_edit'
      //   },
      //   component: () => import('@/pages/wechat_products/edit')
      // },
      // {
      //   path: 'product_category',
      //   name: 'wechat_product_category',
      //   meta: {
      //     icon: 'ios-browsers',
      //     title: '商品分类设置',
      //     require_permission: 'miniprogram:product_category'
      //   },
      //   component: () => import('@/pages/wechat_categories'),
      // },
      // {
      //   path: 'products/:id/detail',
      //   name: 'wechat_products_detail',
      //   meta: {
      //     hideInMenu: true,
      //     icon: 'ios-browsers',
      //     title: '商品详情',
      //     require_permission: 'miniprogram:product_detail'
      //   },
      //   component: () => import('@/pages/wechat_product_skus')
      // },
      // {
      //   path: 'orders',
      //   name: 'wechat_orders',
      //   meta: {
      //     icon: 'ios-browsers',
      //     title: '订单列表',
      //     require_permission: 'miniprogram:order_list'
      //   },
      //   component: () => import('@/pages/wechat_orders')
      // },
      // {
      //   path: 'orders/:id',
      //   name: 'wechat_order_detail',
      //   meta: {
      //     hideInMenu: true,
      //     icon: 'ios-browsers',
      //     title: '订单详情',
      //     require_permission: 'miniprogram:order_detail'
      //   },
      //   component: () => import('@/pages/wechat_orders/show')
      // },
    ],
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true,
      icon: 'md-home',
    },
    component: P401,
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true,
    },
    component: P500,
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true,
    },
    component: P404,
  },
];
